import { BaseApiService } from '@/_services/baseApi.service'

export class ParentService extends BaseApiService {
  constructor () {
    super()
  }

  getAllChildren (personId) {
    const url = `${process.env.VUE_APP_BASE_URL}/v1/student-parent/list/person/${personId}`
    return this.sendGetRequest(url)
  }
}
export default new ParentService()
